import { create } from 'zustand';
import Unidade from '../model/Unidade';
import { UnidadeViewModel } from '../viewmodel/UnidadeViewModel';

interface UnidadeStore {
  unidades: Unidade[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
  fetchPromise: Promise<void> | null;
  fetchUnidades: () => Promise<void>;
  refreshUnidades: () => Promise<void>;
}

const useUnidadeStore = create<UnidadeStore>((set, get) => ({
  unidades: [],
  loading: false,
  error: null,
  loaded: false,
  fetchPromise: null,

  fetchUnidades: async () => {
    const state = get();
    if (state.loaded) {
      return;
    }
    if (state.fetchPromise) {
      return state.fetchPromise;
    }
    
    const fetchPromise = (async () => {
      set({ loading: true, error: null });
      try {
        const lista = await UnidadeViewModel.buscarUnidadesPorNome('');
        set({ 
          unidades: lista.sort((a, b) => a.nome.localeCompare(b.nome)),
          loading: false,
          loaded: true,
          fetchPromise: null
        });
      } catch (error) {
        set({ 
          error: error instanceof Error ? error.message : 'Erro ao carregar unidades',
          loading: false,
          fetchPromise: null
        });
      }
    })();
    
    set({ fetchPromise });
    return fetchPromise;
  },

  refreshUnidades: async () => {
    set({ loading: true, error: null, loaded: false });
    try {
      const lista = await UnidadeViewModel.buscarUnidadesPorNome('');
      set({ 
        unidades: lista.sort((a, b) => a.nome.localeCompare(b.nome)),
        loading: false,
        loaded: true
      });
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Erro ao carregar unidades',
        loading: false 
      });
    }
  }
}));

export default useUnidadeStore;